export default __webpack_public_path__ + "static/media/cardiology.22ccdc01.jpg";